import React, { useState, useEffect } from 'react';
import CButton from '../../components/button/button';
import CTable from '../../components/table/table';
import styles from './accounts.module.scss';
import AddAccount from '../../components/forms/add_accounts';
import CModal from '../../components/modal/modal';
import { addSecondaryAccount, getSecondaryAccounts } from '../../network/user';
import { sort_alphabetically } from '../../utils/lists';
import { IAccount } from '../../utils/interfaces/interfaces';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux';
import { Space } from '../../components/utils/utils';
import { columns_secondary_accounts } from '../../utils/tables';
import { useGetCurrentUserQuery } from '../../api';

const Accounts = () => {
  const [openedModal, setModal] = useState(false);
  const [openedModalPrincipal, setModalPrincipal] = useState(false);
  const [data, setList] = useState([]);
  const [currentAccount, setCurrentAccount] = useState({} as IAccount);

  const id = useAppSelector((state: RootState) => state.session.id) as string;
  const { data: user } = useGetCurrentUserQuery();

  const updateList = () => {
    id &&
      getSecondaryAccounts(id, (data: any) => {
        setList(sort_alphabetically(data.data, 'email'));
      });
  };
  const openEdit = (entry: IAccount) => {
    setCurrentAccount(entry);
    setModal(true);
  };

  useEffect(() => {
    if (user) {
      updateList();
    }
    // eslint-disable-next-line
  }, [user]);

  const addNewAccount = () => {
    setCurrentAccount({} as IAccount);
    setModal(!openedModal);
  };

  const editAccount = () => {
    setModalPrincipal(!openedModalPrincipal);
  };

  return (
    <div className={styles.containerAccounts}>
      <CModal opened={openedModal} openModal={setModal}>
        <AddAccount
          callback={() => {
            updateList();
            setModal(false);
          }}
          addAccount={addSecondaryAccount}
          selectedAccount={currentAccount}
        />
      </CModal>

      <CModal opened={openedModalPrincipal} openModal={setModalPrincipal}>
        <AddAccount
          isPrincipal
          callback={() => {
            setModalPrincipal(false);
          }}
          addAccount={addSecondaryAccount}
          selectedAccount={user}
        />
      </CModal>
      <div className={styles.rowInfo}>
        <div className={styles.text}>
          <p className='subheading-dark bold'>Gestionare conturi secundare</p>
          {user && (
            <p className='body-dark'>
              {`Puteți adaugă până la ${user!.secondaryAccountAllowance} conturi
            secundare.`}
            </p>
          )}
        </div>
        <CButton type='button' label='Editează cont' onClick={editAccount} />
        <Space horizontal={30} vertical={10} />
        <CButton
          type='button'
          label='Adaugă cont nou'
          onClick={addNewAccount}
          disabled={
            data && user && data.length >= user.secondaryAccountAllowance
          }
        />
      </div>
      <CTable
        data={data && data.map((el: IAccount) => ({ ...el, key: el.id }))}
        columns={columns_secondary_accounts(styles, openEdit)}
      />
    </div>
  );
};

export default Accounts;
